// @flow
import _ from "underscore";
import t from './trans';
import GlassProduct, {MeasurementLine, NominalPoint, Endpoint} from "./GlassProduct";

const allowedParams = {
    // csvParamName: [productFieldName, dataType]
    rotated: ["rotated", 'boolean'],
    keeratud_esimene: ["rotatedFirst", 'boolean'],
    keeratud_viimane: ["rotatedLast", 'boolean']
};


/**
 * Parsib GR2 faili sisse ja tekitab sellest mälustrkutuuri
 */
class GrFileParser {
    constructor() {
        this.version = 2;
    }

    /**
     * Parses product data in CSV form and returns product in internal state form
     * @param data
     * @param isOld
     * @returns {GlassProduct}
     */
    parse(data, isOld) {
        let klpmsData = this.parseData(data, isOld);
        if (klpmsData == null) throw t("Invalid data");
        return klpmsData;
    }

    /**
     * Parsib GR2 faili sisse ning tekitab serveri poolt kasutatava tooteinfo JSON struktuuri
     * @param {string} data CSV formaadis GR2 faili andmed
     * @returns {GlassProduct} Tooteinfo esitus
     */
    parseData(data) {
        let version = 1;
        let lineCount = 3;

        let lines = data.split(/\r?\n/);

        let res = new GlassProduct();

        // Nominaalid
        let atmp = [];
        if (lines.length == 0) return null;
        let curLine = lines.shift();
        let els = curLine.split(";");
        if (els.length < 5) {
            // Uus failiversioon:
            version = this.pn(els[0]);

            if (lines.length == 0) return null;
            curLine = lines.shift();
            els = curLine.split(";");
            lineCount = this.pn(els[0]);

            curLine = lines.shift();
        }

        while (typeof curLine !== "undefined") {
            els = curLine.split(";");
            if (els.length < 5) {
                break;
            }
            atmp.push(new NominalPoint({
                value: this.pgn(els[0]),
                upperTolerance1: this.pgn(els[1]),
                upperTolerance2: this.pgn(els[2]),
                lowerTolerance1: this.pgn(els[3]),
                lowerTolerance2: this.pgn(els[4])
            }));
            curLine = lines.shift();
        }
        if (typeof curLine === "undefined") return null;
        if (atmp.length % 3 != 0) return null;
        if (version === 1) lineCount = atmp.length / 3;

        res.version = version;
        res.lineCount = lineCount;

        res.measurementLines = [];
        let k = 0;

        // Mõõtepunktide nominaalväärtused
        for (let i = 0; i < lineCount; i++) {
            let l = new MeasurementLine();
            for (let j = 0; j < 3; j++) {
                switch (j) {
                    case 0:
                        atmp[k].name = "A" + (i+1).toString();
                        break;
                    case 1:
                        atmp[k].name = "B" + (i+1).toString();
                        break;
                    case 2:
                        atmp[k].name = "C" + (i+1).toString();
                        break;
                    default:
                        break;
                }
                l.nominals.push(atmp[k++]);
            }
            res.measurementLines.push(l);
        }

        // Mõõtepunktide kaugused ja korrektsioonid
        for (let i = 0; i < lineCount; i++) {
            for (let j = 0; j < 3; j++) {
                els = curLine.split(";");
                res.measurementLines[i].nominals[j].distance = this.pgn(els[0]);
                res.measurementLines[i].nominals[j].correction = this.pgn(els[1]);

                curLine = lines.shift();
                if (typeof curLine === "undefined") return null;
            }
        }

        // Otspunktid ja trüki kaugused
        for (let i = 0; i < lineCount; i++) {
            for (let j = 0; j < 2; j++) {
                els = curLine.split(";");
                res.measurementLines[i].endpoints[j] = new Endpoint({
                    x: this.pgn(els[0]),
                    y: this.pgn(els[1]),
                    z: this.pgn(els[2]),
                    slopeX: this.pgn(els[3]),
                    slopeY: this.pgn(els[4]),
                    printOffset: this.pgn(els[5])
                });

                curLine = lines.shift();
                if (typeof curLine === "undefined") return null;
            }
        }

        // Joonte pikkused
        atmp = curLine.split(";");
        for (let i = 0; i < lineCount; i++) {
            res.measurementLines[i].lineLength = this.pgn(atmp[i]);
        }

        // Kirjeldused
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["scanCode"] = this.pgs(els[0]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["description"] = this.pgs(els[0]);

        // Klaasi paksus, profiil, trüki profiil:
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["glassThickness"] = this.pgn(els[0]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["measuringProfileGlass"] = this.pgs(els[0]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["measuringProfilePrint"] = this.pgs(els[0]);

        // Omaloomingulised asjad GR2 faili lõpus:
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['diffX'] = this.pgn(els[0]);
        res['diffY'] = this.pgn(els[1]);

        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['offsetX'] = this.pgn(els[0]);
        res['offsetY'] = this.pgn(els[1]);

        if (res['offsetX'] != 0) {
            // Arvutame otspunktide x koordinaadid nihke baasilt ümber:
            for (let i = 0; i < lineCount; i++) {
                for (let j = 0; j < 2; j++) {
                    res.measurementLines[i].endpoints[j].x -= res.offsetX;
                }
            }
        }
        if (res['offsetY'] != 0) {
            // Arvutame otspunktide y koordinaadid nihke baasilt ümber:
            for (let i = 0; i < lineCount; i++) {
                for (let j = 0; j < 2; j++) {
                    res.measurementLines[i].endpoints[j].y -= res.offsetY;
                }
            }
        }

        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['offsetE'] = this.pgn(els[0]);

        res.lineLower = [];
        res.lineUpper = [];
        for (let i = 0; i < lineCount; i++) {
            if (version < 2 && i == Math.floor(lineCount/2)) {
                res.lineUpper[i] = 0;
                res.lineLower[i] = 0;
                continue;
            }
            if (lines.length === 0) return res;
            curLine = lines.shift();
            if (typeof curLine === "undefined") return res;
            els = curLine.split(";");
            res.lineUpper[i] = this.pgn(els[0]);
            res.lineLower[i] = this.pgn(els[1]);
        }

        res.pX = [];
        res.pY = [];
        for (let i = 0; i < lineCount * 3; i++) {
            curLine = lines.shift();
            if (typeof curLine === "undefined") return res;
            els = curLine.split(";");
            res.pX[i] = this.pgn(els[0]);
            res.pY[i] = this.pgn(els[1]);
        }

        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['rotatedLine'] = (els[0] == 0 ? false : true);

        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['toleranceMiddle1'] = this.pgn(els[0]);
        res['toleranceMiddle2'] = this.pgn(els[1]);
        res['toleranceEdge1'] = this.pgn(els[2]);
        res['toleranceEdge2'] = this.pgn(els[3]);

        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        let kood = this.pgs(els[0]);
        res['mirrored'] = false;
        if (kood !== "mirrored") {
            res.codeVariant = kood;

            curLine = lines.shift();
            if (typeof curLine === "undefined") return res;
            els = curLine.split(";");
        }
        if (this.pgs(els[0]) === "mirrored") res['mirrored'] = true;
        else res['mirrored'] = false;

        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        if (els[0] === "PARAMS") this.parseParams(res, lines);

        return res;
    }

    parseParams(res, lines) {
        if (lines === null) return;
        while (lines.length > 0) {
            let curLine = lines.shift();
            let els = curLine.split(";");
            let param = els[0];
            let value = els[1];
            if (param === null || param.length == 0 || value === null || value === "") continue;
            if (allowedParams[param]) {
                res[allowedParams[param][0]] = this.getParamValue(param, value);
            }
        }
    }

    getParamValue(param, value) {
        switch (allowedParams[param][1]) {
            case 'boolean':
                if (value === null) return false;
                value = value.toLowerCase();
                return (value === "true");
            case 'integer':
                if (value === null) return 0;
                return Number.parseInt(value);
            case 'number':
                if (value === null) return 0;
                value = value.replace(',', '.');
                return Number.parseFloat(value);
            default:
                return value;
        }
    }

    /**
     * Tekitab GR2 faili sisu ja tagastab selle. Sisenduks tuleb esitada JSON tooteinfo objekt.
     * @param {GlassProduct} data
     * @returns {string}
     */
    write(data) {
        this.lines = [];
        this.writeCsv([this.version]);
        this.writeCsv([data.lineCount]);
        for (let i = 0; i < data.lineCount; i++) {
            for (let j = 0; j < 3; j++) {
                let n = data.measurementLines[i].nominals[j];
                this.writeCsv([
                    this.wgn(n.value),
                    this.wgn(n.upperTolerance1),
                    this.wgn(n.upperTolerance2),
                    this.wgn(n.lowerTolerance1),
                    this.wgn(n.lowerTolerance2)]);
            }
        }
        for (let i = 0; i < data.lineCount; i++) {
            for (let j = 0; j < 3; j++) {
                let n = data.measurementLines[i].nominals[j];
                this.writeCsv([
                    this.wgn(n.distance),
                    this.wgn(n.correction)]);
            }
        }
        if (data.diffX === undefined || data.diffX === null) data.diffX = 0;
        if (data.diffY === undefined || data.diffY === null) data.diffY = 0;
        for (let i = 0; i < data.lineCount * 2; i++) {
            for (let j = 0; j < 2; j++) {
                let o = data.measurementLines[i].endpoints[j];
                this.writeCsv([
                    this.wgn(o.x + data.diffX),
                    this.wgn(o.y + data.diffY),
                    this.wgn(o.z),
                    this.wgn(o.slopeX),
                    this.wgn(o.slopeY),
                    this.wgn(o.printOffset)
                ]);
            }
        }

        let a = [];
        for (let i = 0; i < data.lineCount; i++) {
            a[i] = this.wgn(data.measurementLines[i].lineLength);
        }
        this.writeCsv(a);
        this.writeCsv([this.wgs(data.scanCode)]);	// SCAN
        this.writeCsv([this.wgs(data.description)]);	// Kirjeldus
        this.writeCsv([this.wgn(data.glassThickness)]);
        this.writeCsv([this.wgs(data.measuringProfileGlass)]);
        this.writeCsv([this.wgs(data.measuringProfilePrint)]);
        // Laiendused:
        this.writeCsv([this.wgn(data.diffX), this.wgn(data.diffY)]);
        this.writeCsv([this.wgn(data.offsetX), this.wgn(data.offsetY)]);
        this.writeCsv([this.wgn(data.offsetE)]);
        for (let i = 0; i < data.lineCount; i++) {
            this.writeCsv([this.wgn(data.lineUpper[i]), this.wgn(data.lineLower[i])]);
        }
        for (let i = 0; i < data.lineCount * 3; i++) {
            this.writeCsv([this.wgn(data.pX[i]), this.wgn(data.pY[i])]);
        }
        this.writeCsv([this.wgs((data.rotatedLine ? '1' : '0'))]);
        this.writeCsv([this.wgn(data.toleranceMiddle1), this.wgn(data.toleranceMiddle2), this.wgn(data.toleranceEdge1), this.wgn(data.toleranceEdge2)]);
        this.writeCsv([data.codeVariant]);
        if (data.mirrored) this.writeCsv(['mirrored']);
        this.writeCsv(['']);
        this.writeCsv(['PARAMS']);
        this.writeParams(data);
        let res = this.lines.join("\r\n") + "\r\n";
        this.lines = [];
        return res;
    }

    writeParams(data) {
        for (let param of _.keys(allowedParams)) {
            let name = allowedParams[param][0];
            if (_.has(data, name) && data[name] !== null && data[name] !== "") {
                this.writeCsv([param, data[name]]);
            }
        }
    }

    writeCsv(data) {
        // NB! Windowsi GR2 tarkvara nõuab, et rea lõpus on ';'
        this.lines.push(data.join(';') + ";");
    }

    pn(s) {
        if (!s) return 0;
        s = s.replace(",", ".");
        s = s.replace("\n", "");
        s = s.replace("\r", "");
        return Number.parseFloat(s);
    }

    pgn(s) {
        return Math.round(this.pn(s) * 10);
    }

    pgs(s) {
        if (!s) return s;
        s = s.replace("\n", "");
        s = s.replace("\r", "");
        return s;
    }

    wgn(s) {
        if (!s) return "0";
        s = Math.round(s) / 10;
        return s.toString().replace(".", ",");
    }

    wgs(s) {
        if (s === undefined || s === null || Number.isNaN(s)) return '';
        return s.toString();
    }
}

export default GrFileParser;
